export const HEIGHT_MIN_IN = 48;   // 4'0"  — shortest clinically relevant adult
export const HEIGHT_MAX_IN = 84;   // 7'0"  — tallest practical upper bound
export const WEIGHT_MIN_KG = 20;   // extreme underweight floor
export const WEIGHT_MAX_KG = 150;
export const HEIGHT_DEFAULT_IN = 64;  // 5'4" — average adult height
export const WEIGHT_DEFAULT_KG = 70; 